"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollateralAction = void 0;
const models_1 = require("../../models");
const refreshReserve_1 = require("./util/refreshReserve");
const initObligation_1 = require("./util/initObligation");
const withdrawMining_1 = require("./util/withdrawMining");
const constant_1 = require("../../constant");
const larixInstructionCollector_1 = require("../../utils/larixInstructionCollector");
const baseAction_1 = require("./util/baseAction");
class CollateralAction extends baseAction_1.BaseAction {
    collateral(reserveData, larixMining, larixObligation) {
        return __awaiter(this, void 0, void 0, function* () {
            const depositReserveDetail = reserveData.state;
            const lendingProgramID = this.marketConfig.programId;
            const collateralTokenAccount = this.userInfo.getCollateralTokenAccount(reserveData);
            if (collateralTokenAccount == undefined) {
                throw new Error("Invalid collateral token account");
            }
            let mining = larixMining === null || larixMining === void 0 ? void 0 : larixMining.state;
            let obligation = larixObligation === null || larixObligation === void 0 ? void 0 : larixObligation.state;
            const connection = this.userInfo.connection;
            const larixTransaction = new larixInstructionCollector_1.LarixInstructionCollector(this.wallet);
            const depositReserveAddress = depositReserveDetail.pubkey;
            if (mining === undefined) {
                const myMinings = yield this.userInfo.getMiningOfMarket(depositReserveDetail.info.lendingMarket, lendingProgramID);
                if (myMinings.length > 0) {
                    mining = myMinings[0];
                }
            }
            if (mining === undefined) {
                throw new Error("Invalid mining account");
            }
            const appendReserves = [];
            if (obligation == undefined) {
                const myObligations = yield this.userInfo.getObligationOfMarket(depositReserveDetail.info.lendingMarket, lendingProgramID);
                if (myObligations.length > 0) {
                    obligation = myObligations[0];
                }
            }
            let myObligationAddress;
            if (obligation == undefined) {
                myObligationAddress = yield (0, initObligation_1.initObligation)(connection, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, this.userInfo.publicKey, depositReserveDetail.info.lendingMarket, lendingProgramID);
            }
            else {
                myObligationAddress = obligation.pubkey;
                let newDeposit = true;
                obligation.info.deposits.map(deposit => {
                    if (deposit.depositReserve.equals(depositReserveAddress)) {
                        newDeposit = false;
                    }
                });
                if (newDeposit) {
                    if (obligation !== undefined) {
                        obligation.info.deposits.map(deposit2 => {
                            appendReserves.push(deposit2.depositReserve);
                        });
                        obligation.info.borrows.map(borrow => {
                            appendReserves.push(borrow.borrowReserve);
                        });
                    }
                }
                console.log("appendReserves", appendReserves);
            }
            yield (0, refreshReserve_1.refreshReserve)(connection, this.marketConfig, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, depositReserveDetail, lendingProgramID);
            mining.info.miningIndices.map((miningIndex) => __awaiter(this, void 0, void 0, function* () {
                if (miningIndex.reserve.equals(depositReserveDetail.pubkey)) {
                    yield (0, withdrawMining_1.withdrawMining)(connection, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, 
                    // @ts-ignore
                    mining.pubkey, collateralTokenAccount.pubkey, depositReserveDetail, constant_1.U64_MAX, this.userInfo.publicKey, depositReserveDetail.info.lendingMarket, lendingProgramID, this.marketConfig.authorityId);
                }
            }));
            yield (0, refreshReserve_1.refreshReserve)(connection, this.marketConfig, larixTransaction.signers, larixTransaction.instructions, larixTransaction.cleanupInstructions, depositReserveDetail, lendingProgramID);
            larixTransaction.instructions.push((0, models_1.depositObligationCollateralInstruction)(constant_1.U64_MAX, collateralTokenAccount.pubkey, depositReserveDetail.info.collateral.supplyPubkey, depositReserveAddress, myObligationAddress, depositReserveDetail.info.lendingMarket, lendingProgramID, this.marketConfig.authorityId, this.userInfo.publicKey, this.userInfo.publicKey, appendReserves));
            return larixTransaction;
        });
    }
}
exports.CollateralAction = CollateralAction;
